export default __webpack_public_path__ + "assets/fonts/bca062aca9a5f44fc38060593dd97bab.woff2";